export type FilterOperatorName = string
export type FilterOperatorType = string

export interface FilterOperator {
  type: FilterOperatorType
  name: FilterOperatorName
}

export const BuiltinFilterOperator = {
  equals: {
    type: 'equals',
    name: 'Equals',
  },
  notEqual: {
    type: 'notEqual',
    name: 'Not Equal',
  },
  lessThan: {
    type: 'lessThan',
    name: 'Less Than',
  },
  lessThanOrEqual: {
    type: 'lessThanOrEqual',
    name: 'Less Than Or Equal',
  },
  greaterThan: {
    type: 'greaterThan',
    name: 'Greater Than',
  },
  greaterThanOrEqual: {
    type: 'greaterThanOrEqual',
    name: 'Greater Than Or Equal',
  },
  between: {
    type: 'between',
    name: 'Between',
  },
  in: {
    type: 'in',
    name: 'In',
  },
  notIn: {
    type: 'notIn',
    name: 'Not In',
  },
  contains: {
    type: 'contains',
    name: 'Contains',
  },
  on: {
    type: 'on',
    name: 'On',
  },
  notOn: {
    type: 'notOn',
    name: 'Not On',
  },
  before: {
    type: 'before',
    name: 'Before',
  },
  onOrBefore: {
    type: 'onOrBefore',
    name: 'On Or Before',
  },
  after: {
    type: 'after',
    name: 'After',
  },
  onOrAfter: {
    type: 'onOrAfter',
    name: 'On Or After',
  },
  blank: {
    type: 'blank',
    name: 'Blank',
  },
  notBlank: {
    type: 'notBlank',
    name: 'Not Blank',
  },
  notContains: {
    type: 'notContains',
    name: 'Not Contains',
  },
  equalsAbsolute: {
    type: 'equalsAbsolute',
    name: 'Equals Absolute',
  },
}
